<div class="flex flex-row justify-between items-center min-h-10" [class]="!chart()?.export?classes():''">
    <h5 [ngClass]="{'text-lg font-semibold pb-2.5':chart()?.export}" title
        class='text-sm text-zen font-medium title leading-10'><ng-content select="[title]"></ng-content></h5>

    @if (!chart()?.export) {
    <div class="flex flex-row items-end justify-end gap-2">
        <ng-content select="[options]"></ng-content>
        @if (chart()?.type && chartTypes?.length && !chart()?.custom) {
        <!-- <zen-select [options]="chartTypes" [formControl]="chartType">
            <a trigger [zenButton]="{type:ZenButtonType.Ghost, icon:true}"><i class="fa-regular text-lg"
                    [class]="selectedChartTypeIcon"></i> </a>
            <ng-template #optionTemplate let-option>
                <i [zenButton]="{type:ZenButtonType.Secondary, icon:true}" [class]="option?.icon" class="fa-regular"></i>
            </ng-template>
        </zen-select> -->
        <zen-menu>
            <a trigger [zenButton]="{type:ZenButtonType.Ghost, icon:true}"><i class="fa-regular text-lg"
                    [TourStep]="chartTypeTour()" [class]="selectedChartTypeIcon"></i> </a>
            @for (option of chartTypes; track $index) {
            <a class="!px-0 cursor-pointer" (click)="chartType.setValue(option.key)"> <i
                    [zenButton]="{type:ZenButtonType.Secondary, icon:true}" [class]="option?.icon"
                    class="fa-regular pointer-events-none"></i></a>
            }
        </zen-menu>

        }


        <zen-menu>
            <a trigger [zenButton]="{type:ZenButtonType.Ghost, icon:true}"><i
                    class="fa-regular fa-ellipsis text-lg"></i></a>
            <a (click)="exportRaw()" zenMenuItem><i class="fa-regular fa-table"></i>{{ "txt_RawData_453" |
                translate:language():ModuleNames.Shared }}</a>
            <a (click)="exportPDF()" zenMenuItem><i class="fa-regular fa-download"></i> {{ "txt_Export_229" |
                translate:language():ModuleNames.Shared }}</a>
        </zen-menu>
    </div>
    }
</div>


<ng-content select="[extra]"></ng-content>